import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ icon, label, value, subValue, trend, trendDirection, iconColor = 'text-primary' }) => {
  const getGradientClass = () => {
    if (iconColor?.includes('success')) return 'from-success to-emerald-400';
    if (iconColor?.includes('warning')) return 'from-warning to-amber-400';
    if (iconColor?.includes('primary')) return 'from-primary to-secondary';
    if (iconColor?.includes('accent')) return 'from-accent to-cyan-400';
    return 'from-primary to-secondary';
  };

  return (
    <div className="group relative bg-white border border-slate-200/60 rounded-2xl p-24 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-slate-50/50 opacity-0 group-hover:opacity-100 transition-opacity"></div>
      
      <div className="relative">
        <div className="flex items-start justify-between mb-16">
          <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${getGradientClass()} flex items-center justify-center shadow-lg`}>
            <Icon name={icon} size={24} className="text-white" />
          </div>
          {trend && (
            <div className={`flex items-center gap-6 px-12 py-6 rounded-lg text-xs font-bold ${
              trendDirection === 'up' ? 'bg-success/10 text-success' : 
              trendDirection === 'down'? 'bg-error/10 text-error' : 'bg-slate-100 text-slate-600'
            }`}>
              <Icon name={trendDirection === 'up' ? 'TrendingUp' : trendDirection === 'down' ? 'TrendingDown' : 'Minus'} size={14} />
              {trend}
            </div>
          )}
        </div>
        
        <div className="space-y-8">
          <h3 className="text-4xl font-bold bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">
            {value}
          </h3>
          <p className="text-sm text-slate-600 font-medium">
            {label}
          </p>
          {subValue && (
            <p className="text-xs text-slate-500">
              {subValue}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default MetricsCard;